module.exports = __webpack_public_path__ + "static/media/graph_body_red.91e84a8c.png";